import "./styles.scss";
import "./global-styles.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import App from "App";
import ReduxToastr from "react-redux-toastr";
import { UIControllerProvider } from "context";
import { store, history } from "redux/store";
import config from "./config/config";
import { PRODUCT_VERSION } from "./generated/versionCatalog";
import { Icon, IconButton } from "@mui/material";
import { preloadScadaFonts } from "pages/scadaDesigner/scadaFonts";

const isEmbeddedRuntimeFrame = new URLSearchParams(window.location.search).get("embed") === "1";

if (!isEmbeddedRuntimeFrame) {
  // eslint-disable-next-line no-console
  console.info(`
#####################################################
# Product version  : ${PRODUCT_VERSION}
# BACKEND URL      : ${config.API_ENDPOINT}
#####################################################
`);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
const renderApplication = () => root.render(
  <Provider store={store}>
    <Router history={history}>
      <UIControllerProvider>
        {window.require && window.require("electron") && (
          <IconButton
            size="small"
            color="error"
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 9999,
              background: "lightGrey",
            }}
            onClick={() => {
              if (window.require && window.require("electron")) {
                const electron = window.require("electron");
                if (electron) {
                  electron.ipcRenderer.send("close", "closing application");
                }
              }
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        )}
        <App />
        <ReduxToastr
          timeOut={5000}
          closeOnToastrClick
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
          preventDuplicates
        />
      </UIControllerProvider>
    </Router>
  </Provider>
);

preloadScadaFonts().then(renderApplication, renderApplication);
